<template>
  <div>
    <v-container>
      <div>
        <WhitelabelSteps></WhitelabelSteps>
      </div>
    </v-container>
    <div style="background-color: #E7EBF5" class="mt-12 py-12">
      <v-container>
        <WhitelabelShare></WhitelabelShare>
      </v-container>
    </div>
    <v-container>
      <div class="pt-12 pb-16">
        <WhitelabelInvestiment></WhitelabelInvestiment>
      </div>
      <!-- <div>
      <WhitelabelModel></WhitelabelModel>
    </div> -->
    </v-container>
    <v-footer dark>
      <v-container class="py-12" dark>
        <div class="d-flex justify-space-between mx-n4 pb-9  flex-wrap">
          <div class="px-4">
            <v-img src="@/assets/logo.svg" width="100"></v-img>
            <div class="text-p">
              © 2015-{{ year }} The Media Trade<br>23.659.903/0001-84<br>{{ $t('footer.copy') }}
            </div>
          </div>
          <div class="d-flex ma-3 flex-md-row flex-column">
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.company.title') }}</div>
              <v-btn text v-for="(item, index) in $t('footer.company.links')" :key="index" :href="item.link">{{
                item.text
                }}</v-btn>

            </div>
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.follow_us.title') }}</div>
              <v-btn text target="_blank" href="https://www.linkedin.com/company/media-trade"><v-icon
                  class="mr-2">mdi-linkedin</v-icon>LinkedIn <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
              <v-btn color="white" large class="mx-4 mt-9 primary--text" href="https://store.themediatrade.com"
                target="_blank">The Media Store <v-icon small class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div class="mx-n4">
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.privacy') }}</v-btn>
          <v-divider vertical></v-divider>
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.terms') }}</v-btn>
        </div>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import moment from 'moment'
import WhitelabelInvestiment from '@/components/whitelabel/WhitelabelInvestiment.vue';
import WhitelabelShare from '@/components/whitelabel/WhitelabelShare.vue';
import WhitelabelSteps from '@/components/whitelabel/WhitelabelSteps.vue';
// import WhitelabelModel from '@/components/whitelabel/WhitelabelModel.vue'


export default {
  name: 'HomePage',

  components: {
    WhitelabelSteps,
    WhitelabelShare,
    WhitelabelInvestiment,
    // WhitelabelModel
  },
  methods: {
    goToPage() {
      this.$router.push('/whitelabel')
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    year() {
      return moment().format('Y')
    }
  }
}
</script>
